import { createClient as _createClient, createCache, QueryResponse } from 'react-fetching-library';
import Cookies from 'js-cookie';

import config from '../../config/index';

import merge from 'lodash/merge';
import { K_USER_TOKEN_COOKIE_KEY } from '../../../user/utils/auth/AuthProvider';
import { SentryClient } from '../../../../pages/_app';

const cache = createCache<QueryResponse<any>>(
  action => {
    return action.endpoint.includes('wp.rupiahtoken.com'); // @TODO: cache action by fetchPolicy
  },
  response => {
    return new Date().getTime() - response.timestamp < 1000 * 60 * 60 * 24 * 3; // 3 day
  }
);

export const requestHostInterceptor = overrideAction => client => async action => {
  if (action.skipToken) {
    return action;
  }
  const endpoint =
    action.endpoint && action.endpoint.includes('http')
      ? action.endpoint
      : `${config.apiURL}${action.url || action.endpoint}`;
  const latestFirebaseToken = Cookies.get(K_USER_TOKEN_COOKIE_KEY)
    ? {
        headers: {
          Authorization: `Bearer ${Cookies.get(K_USER_TOKEN_COOKIE_KEY)}`
        }
      }
    : {}; // this cookies only available for client side.
  return merge(
    {},
    {
      ...action,
      endpoint,
      headers: {
        'Content-Type': 'application/json'
      }
    },
    overrideAction,
    latestFirebaseToken
  );
};

const sendSentryIfErrorInterceptor = client => async (action, response) => {
  if (response.payload.error) {
    SentryClient.captureException(response);
  }
  return response;
};

export function createClient(payload) {
  return _createClient({
    requestInterceptors: [requestHostInterceptor(payload)],
    responseInterceptors: [sendSentryIfErrorInterceptor],
    cacheProvider: cache
  });
}
